import { useQuery } from "react-query";
import TopInTransitLanesApi from "./TopInTransitLanes.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useTopInTransitLanes(query: IWidgetQuery) {
	return useQuery(["fetchTopInTransitLanes", query], TopInTransitLanesApi.getData);
}